import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './UserArea.css';

class UserArea extends Component {

    formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            const date = new Date(dateString);
            return date.toDateString();
        } catch (e) {
            return dateString;
        }
    };

    renderLicenseCard = (primary, index) => {
        const { connectedPrimaries } = this.props;

        const primaryId = primary.primaryId || primary.id;
        const isOnline = connectedPrimaries && connectedPrimaries.some(p => p.id == primaryId);

        const expirationDate = primary.expirationDateReadable || primary.expirationDate;
        const isExpired = expirationDate && new Date(expirationDate) < new Date();

        const connectedPrimary = connectedPrimaries && connectedPrimaries.find(p => p.id == primaryId);

        let statusClass = 'status-offline';
        let statusText = 'OFFLINE';

        if (connectedPrimary && connectedPrimary.isActive) {
            if (connectedPrimary.isBroadcasting) {
                statusClass = 'status-broadcasting';
                statusText = 'BROADCASTING';
            } else {
                statusClass = 'status-online';
                statusText = 'ONLINE';
            }
        }

        let permissionsDisplay = 'N/A';
        const permissions = primary.licensePermission || primary.permissions;
        if (permissions && Array.isArray(permissions)) {
            permissionsDisplay = permissions.join(', ');
        } else if (permissions) {
            permissionsDisplay = permissions;
        }

        return (
            <div key={primary.id || index} className="license-card">
                <div className="license-header">
                    <div className="license-title-container">
                        <div className="license-title">{primary.primaryName || primary.username || `License #${index + 1}`}</div>
                        {isExpired && <div className="expired-badge">EXPIRED</div>}
                    </div>
                    <div className={`status-text-indicator ${statusClass}`}>{statusText}</div>
                </div>

                <div className="license-details">
                    <div className="detail-row">
                        <span className="detail-label">Registration Date</span>
                        <span className="detail-value">{this.formatDate(primary.registerDateReadable || primary.registrationDate)}</span>
                    </div>
                    <div className="detail-row">
                        <span className="detail-label">Expiration Date</span>
                        <span className="detail-value">{this.formatDate(primary.expirationDateReadable || primary.expirationDate)}</span>
                    </div>
                    <div className="detail-row">
                        <span className="detail-label">Subscription</span>
                        <span className="detail-value">{primary.licenseType || 'N/A'}</span>
                    </div>
                    <div className="detail-row">
                        <span className="detail-label">Plan</span>
                        <span className="detail-value permissions-text" title={permissionsDisplay}>{permissionsDisplay}</span>
                    </div>
                    <div className="detail-row">
                        <span className="detail-label">Platform</span>
                        <span className="detail-value">{primary.deviceOS || 'N/A'}</span>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const {
            companyName,
            adminFirstName,
            adminLastName,
            email,
            phone,
            primariesUserDetails
        } = this.props;

        let primariesList = [];
        if (Array.isArray(primariesUserDetails)) {
            primariesList = primariesUserDetails;
        } else if (typeof primariesUserDetails === 'object' && primariesUserDetails !== null) {
            // Map object keys to IDs to ensure 'id' property exists on the primary object
            primariesList = Object.keys(primariesUserDetails).map(key => ({
                ...primariesUserDetails[key],
                id: primariesUserDetails[key].id || key
            }));
        }

        return (
            <div className="user-area-page">
                <div className="user-area-container">

                    {/* General Customer Info Section */}
                    <div className="user-info-section">
                        <div className="user-info-header">Account Details</div>
                        <div className="user-info-grid">
                            <div className="info-item">
                                <label>Company</label>
                                <div className="info-value">{companyName || 'N/A'}</div>
                            </div>
                            <div className="info-item">
                                <label>Admin Name</label>
                                <div className="info-value">
                                    {[adminFirstName, adminLastName].filter(Boolean).join(' ') || 'N/A'}
                                </div>
                            </div>
                            <div className="info-item">
                                <label>Email</label>
                                <div className="info-value">{email || 'N/A'}</div>
                            </div>
                            <div className="info-item">
                                <label>Phone</label>
                                <div className="info-value">{phone || 'N/A'}</div>
                            </div>
                        </div>
                    </div>

                    <div className="licenses-section-header">
                        <h2>Licenses</h2>
                        <span className="license-count">{primariesList.length} Active</span>
                    </div>

                    <div className="licenses-grid">
                        {primariesList.length > 0 ? (
                            primariesList.map(this.renderLicenseCard)
                        ) : (
                            <div className="no-licenses">No licenses found.</div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

UserArea.propTypes = {
    companyName: PropTypes.string,
    adminFirstName: PropTypes.string,
    adminLastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    primariesUserDetails: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    connectedPrimaries: PropTypes.array,
};

export default UserArea;
